import { render, staticRenderFns } from "./AlertEditForm.vue?vue&type=template&id=0798c866&scoped=true&"
import script from "./AlertEditForm.vue?vue&type=script&lang=ts&"
export * from "./AlertEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./AlertEditForm.vue?vue&type=style&index=0&id=0798c866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0798c866",
  null
  
)

export default component.exports